const points = [
  { value: '15+', label: 'Spécialités couvertes', icon: 'ri-stethoscope-line' },
  { value: '10', label: 'Quartiers de Rabat', icon: 'ri-map-pin-line' },
  { value: '7j', label: 'Fenêtre de disponibilité', icon: 'ri-calendar-line' },
  { value: '<60s', label: 'Pour prendre RDV', icon: 'ri-timer-flash-line' },
];

export default function Trust() {
  return (
    <section className="py-14 bg-background-50 border-y border-background-200">
      <div className="px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {points.map((p) => (
            <div key={p.label} className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                <i className={`${p.icon} text-xl text-primary-700 w-5 h-5 flex items-center justify-center`} />
              </div>
              <div>
                <p className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-none">{p.value}</p>
                <p className="text-xs text-foreground-600 mt-1">{p.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}